<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class="mb25 s_flex_bian_c">
        <span class='mr15'>
          <a-button type="primary" v-has:orderFreightCreate="()=>openAdd(0)">
            <PlusOutlined />
            新建运费模板
          </a-button>
        </span>
      </div>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:name="{ record }">
          <div>{{record.name}}<span class="s_c999" v-if='record.is_default == 1'>（系统默认）</span></div>
        </template>
        <template v-slot:action="{ record }">
          <a-button v-has:orderFreightEdit="()=>openAdd(record)" type="primary" class="m-r-10">编辑</a-button>
          <a-button v-has:orderFreightDel="()=>expressDel(record)" danger>删除</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" :title="formData.id ? '编辑运费模板':'添加运费模板'" centered :width='800' :footer="null" v-model:visible="visible" destroyOnClose>
    <addFreight :formData='formData' v-on:onsubmit='onsubmit'></addFreight>
  </a-modal>
</template>
<script>
  import { PlusOutlined} from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getDeliveryList, setDeliveryDel,getDeliveryMore } from "@/api/order";
  import { iscode } from "@/utils/app";
  import addFreight from './components/add.vue'
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
  };
  export default {
    components: { PlusOutlined,addFreight },
    setup(props, ctx) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total: 1,
        visible: false,
        formData:{}
      });
      let columns = [
        {
          title: "运费模板名称",
          key: "name",
          slots: { customRender: "name" },
        },
        {
          title: '使用商品数',
          dataIndex: "total",
          key: "total",
        },
           {
          title: '是否满额包邮',
          dataIndex: "is_full_package",
          key: "is_full_package",
            customRender: ({ record }) => {
            return record.is_full_package ? '是' : '否'
          }
        },
        {
          title: '最后编辑时间',
          dataIndex: "update_time",
          key: "update_time",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const expressDel = async(e) =>{
        $Modal.confirm({
          centered:true,
          title:'运费模板删除',
          content: '删除后该运费模板将无法恢复，您确定要删除该运费模板吗？', onOk:async () => {
            let res = await setDeliveryDel(e.id).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            }else {
              message.error(res.msg);
            }
          }
        })
      }
      //打开弹窗
      const openAdd = async(e) => {
        if (e == 0) {
          state.visible = true
          state.formData = {}
        } else {
          let res = await getDeliveryMore(e.id).then(res => res.data);
          if (iscode(res)) {
            state.formData = JSON.parse(JSON.stringify(res.data))
            state.visible = true
          }else {
            message.error(res.msg);
          }
        }
      }
      //提交完毕
      const onsubmit = () =>{
        initData(search.value);
        state.visible = false
      }
      //获取列表
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getDeliveryList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        openAdd,
        expressDel,
        onsubmit
      };
    },
  };
</script>